import { Col, Form, FormCheck, Row } from "react-bootstrap";

const PlaylistsSynopsis = (
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked
) => {
  return (
    <Form.Group controlId="synopsisInput">
      <Row className="align-items-center pt-2 ">
        <Form.Label
          column
          sm="2"
        >
          Synopsis:
        </Form.Label>
        <Col>
          <Form.Control
            as="textarea"
            size="sm"
            value={programDetails.synopsis.synopsis}
            disabled={isLocked}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                synopsis: {
                  ...programDetails.synopsis,
                  synopsis: e.target.value,
                  isDirty: true,
                },
              });
              setFormEdited(true);
            }}
            rows={4}
            className={programDetails.synopsis.isDirty && "text-danger"}
          />
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.synopsis.isDirty}
            disabled={isLocked}
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                synopsis: {
                  ...programDetails.synopsis,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
          />
        </Col>
      </Row>
    </Form.Group>
  );
};
export default PlaylistsSynopsis;
